import React, { useEffect, useState } from 'react';

const Notification = ({ message, type = 'success', onClose, duration = 2000 }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration - 300);
    const timer2 = setTimeout(() => onClose(), duration);
    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
    };
  }, [duration, onClose]);

  const bgColor = type === 'success'
    ? 'bg-green-50'
    : type === 'error'
    ? 'bg-red-50'
    : 'bg-blue-50';
  const textColor = type === 'success'
    ? 'text-green-600'
    : type === 'error'
    ? 'text-red-600'
    : 'text-blue-600';

  return (
    <div className={`
      fixed bottom-4 right-4 p-4 rounded-lg shadow-lg min-w-[300px] flex items-center justify-between
      text-sm ${bgColor} ${textColor}
      transition-all duration-300
      ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
    `}>
      <span className="flex-1">{message}</span>
      <button onClick={onClose} className="ml-4 p-1 hover:bg-white/50 rounded-full transition-colors">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
  );
};

export default Notification; 